export default __webpack_public_path__ + "static/media/pngwing.51738226.png";